var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.857,
    y1: 0.173,
    x2: 0.219,
    y2: 0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 21.5,
    rx: 20,
    ry: 20.5,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,38A19,19,0,0,1,5.565,5.565a19,19,0,0,1,26.87,26.87A18.877,18.877,0,0,1,19,38Zm4.481-18.925A2.335,2.335,0,0,1,25.567,20.8v8.648h4.413V20.623h-.088c-.409-3.311-2.258-5.238-5.208-5.427-.109-.008-.218-.012-.327-.012A5.039,5.039,0,0,0,20.273,17.8v-2.03H15.86V29.448h4.413v-9.09c.808-.943,1.414-1.195,3.088-1.28C23.4,19.076,23.443,19.075,23.481,19.075ZM8.359,15.768V29.448h4.412V15.768Zm2.205-7.06a2.647,2.647,0,1,0,2.648,2.648A2.65,2.65,0,0,0,10.564,8.709Z",
    transform: "translate(4 5)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.021e3f6f7001a7df31f24eaeac3b9202.svg";
export { ForwardRef as ReactComponent };